var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99987 1.33301H11.3333V9.99967L6.66656 14.6663L5.83322 13.833C5.75544 13.7552 5.69155 13.6497 5.64155 13.5163C5.59155 13.383 5.56655 13.2552 5.56655 13.133V12.8997L6.29989 9.99967H1.99985C1.64429 9.99967 1.33318 9.86634 1.06651 9.59967C0.799839 9.33301 0.666504 9.0219 0.666504 8.66634V7.33301C0.666504 7.25523 0.677615 7.1719 0.699838 7.08301C0.72206 6.99412 0.744282 6.91079 0.766505 6.83301L2.76652 2.13301C2.86653 1.91079 3.03319 1.7219 3.26653 1.56634C3.49987 1.41079 3.74431 1.33301 3.99987 1.33301ZM9.99993 2.66634H3.99987L1.99985 7.33301V8.66634H7.99991L7.0999 12.333L9.99993 9.43301V2.66634ZM11.3333 9.99967V8.66634H13.3333V2.66634H11.3333V1.33301H14.6666V9.99967H11.3333Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/Thumbs Down.5096cb47a22bbff724aea601a2d22a1a.svg";
export { ForwardRef as ReactComponent };